// src/components/DropPromptModal/DropPromptModal.js
import React, { useState } from 'react';
import './DropPromptModal.css';

const DropPromptModal = ({
  isOpen,
  type, // 'entity' or 'individual'
  templateName,
  existingItems = [],
  onCreateNew,
  onUseExisting,
  onCancel
}) => {
  const [selectedExisting, setSelectedExisting] = useState(null);

  if (!isOpen) return null;

  const typeLabel = type === 'entity' ? 'société' : 'personne';
  const typeIcon = type === 'entity' ? '🏢' : '👤';

  const handleUseExisting = () => {
    if (selectedExisting) {
      onUseExisting(selectedExisting);
    }
  };

  const getItemName = (item) => {
    if (type === 'entity') {
      return item.entity_name || item.name || 'Société sans nom';
    }
    return `${item.first_name || ''} ${item.last_name || ''}`.trim() || 'Personne sans nom';
  };

  return (
    <div className="drop-prompt-overlay" onClick={onCancel}>
      <div className="drop-prompt-modal" onClick={e => e.stopPropagation()}>
        <div className="drop-prompt-header">
          <span className="drop-prompt-icon">{typeIcon}</span>
          <h3>Ajouter une {typeLabel}</h3>
          <button className="close-btn" onClick={onCancel}>&times;</button>
        </div>

        <div className="drop-prompt-content">
          <p className="drop-prompt-template-name">
            Template: <strong>{templateName}</strong>
          </p>

          <div className="drop-prompt-options">
            {/* Option 1: Create new */}
            <button
              className="drop-prompt-option create-new"
              onClick={onCreateNew}
            >
              <span className="option-icon">+</span>
              <div className="option-text">
                <strong>Créer une nouvelle {typeLabel}</strong>
                <span>Basée sur le template "{templateName}"</span>
              </div>
            </button>

            {/* Option 2: Use existing (if any exist) */}
            {existingItems.length > 0 && (
              <div className="drop-prompt-existing">
                <div className="existing-header">
                  <span className="option-icon">↩</span>
                  <strong>Utiliser une {typeLabel} existante</strong>
                </div>
                <div className="existing-list">
                  {existingItems.map(item => (
                    <label
                      key={item.id || item.entity_id || item.individual_id}
                      className={`existing-item ${selectedExisting?.id === item.id ? 'selected' : ''}`}
                    >
                      <input
                        type="radio"
                        name="existing"
                        checked={selectedExisting?.id === item.id}
                        onChange={() => setSelectedExisting(item)}
                      />
                      <span className="item-name">{getItemName(item)}</span>
                    </label>
                  ))}
                </div>
                <button
                  className="btn-use-existing"
                  disabled={!selectedExisting}
                  onClick={handleUseExisting}
                >
                  Utiliser la sélection
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="drop-prompt-footer">
          <button className="btn-cancel" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default DropPromptModal;
